// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"855282de","453":"e9b5fb19","455":"d3ed649c"}[chunkId] + ".chunk.js";
};